import { render, staticRenderFns } from "./AlertCircleIcon.vue?vue&type=template&id=20301e32&"
import script from "./AlertCircleIcon.vue?vue&type=script&lang=js&"
export * from "./AlertCircleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports